import { clearApiKey } from "../../utils/apiKey";
import React from "react";
class LogoutPopUp extends React.Component {
  state = {
    displayPopup: this.props.displayPopup,
    show: false,
    active: false,
    SearchResult: [],
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.displayPopup) {
      this.setState({ active: true });
      setTimeout(() => {
        this.setState({ show: true });
      }, 350);
    } else {
      this.setState({ show: false });
      setTimeout(() => {
        this.setState({ active: false });
      }, 350);
    }
  }
  logout = () => {
    clearApiKey();
    localStorage.setItem("infoSuccess", "");
    localStorage.setItem("carId2", "");
    localStorage.setItem("carName", "");
    localStorage.clear();

    const url = new URL(window.location.href);
    window.location.replace(url.origin);
  };
  logoutCancel = () => {
    this.props.hidePopup();
  };
  render() {
    return (
      <main>
        <div
          className={`logoutPopUp SearchPopUp ${
            this.state.active ? " active" : ""
          } ${this.state.show ? "show" : ""} `}>
          <div
            className='dark-layout darkSuperApp'
            onClick={() => this.props.hidePopup()}></div>
          <div className='popupMain'>
            <span className='logOut'>خروج از حساب کاربری</span>
            <span className='sure'>آیا مطمین هستید؟</span>
            <div className='logoutBtn'>
              <button className='yes' onClick={() => this.logout()}>
                بله
              </button>
              <button className='no' onClick={() => this.logoutCancel()}>
                خیر
              </button>
            </div>
          </div>
        </div>
      </main>
    );
  }
}
export default LogoutPopUp;
